// extracted by mini-css-extract-plugin
export default {"component":"b3TJ0O","indicator":"c3TJ0O"};